export default __webpack_public_path__ + "static/media/meltoIdoskort.172d2d27.png";